import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { isEmpty, pathOr } from 'ramda'
import { Component } from 'react'

import CampaignContentSMS from '@/app/module/campaigns/component/item/steps/content/sms'
import type { LanguageType } from '@/app/module/campaigns/helpers'
import type { ContentSMS, MessagesState, SMSBlastCampaignItem, SMSMessage } from '@/app/module/campaigns/types'
import { PartFamily } from '@/app/module/campaigns/types'

type Props = {
  item: SMSBlastCampaignItem
  messages: Pick<MessagesState, 'personalizationList'>

  onChange: (item: SMSBlastCampaignItem) => void
}

type State = {
  message: ContentSMS
}

type ValidateProps = {
  item: Pick<SMSBlastCampaignItem, 'variables'>
}

type UpdateFn = (state: Readonly<State>) => { message: ContentSMS }

const defaultLanguages: LanguageType[] = []

const defaultMessage: ContentSMS = {
  text: '',
}

export default class CampaignBlastContent extends Component<Props, State> {
  state = {
    message: this.props.item.variables?.message || defaultMessage,
  }

  unmounting = false

  static validate({ item }: ValidateProps) {
    return !isEmpty(pathOr({}, ['variables', 'message'], item))
  }

  componentWillUnmount() {
    this.unmounting = true
  }

  changeHandler = (value: Partial<SMSMessage>) => {
    const nextMessage = value.message
    if (!nextMessage) return

    this.update(({ message }) => ({
      ...message,
      message: nextMessage,
    }))
  }

  update(fn: UpdateFn) {
    const { item, onChange } = this.props
    const { message } = fn(this.state)

    if (!this.unmounting) {
      this.setState({ message })
    }

    // Publish before navigation can discard the local state update.
    onChange({
      ...item,
      variables: {
        ...item.variables,
        message,
      },
    })
  }

  render() {
    const {
      messages: { personalizationList = {} },
    } = this.props
    const messageItem: SMSMessage = {
      changed: false,
      hasQuestion: false,
      id: 'smsblast-message',
      message: this.state.message as ContentSMS,
      type: PartFamily.SMS,
    }
    const defaultLanguage = ''
    const languages = defaultLanguages

    return (
      <div>
        <div key={0}>
          <Card style={{ margin: '0' }}>
            <CardContent>
              <Toolbar
                style={{
                  margin: '-24px -24px 12px',
                  backgroundColor: '#f5f5f5',
                  justifyContent: 'space-between',
                }}
              >
                <Typography>Specify what SMS you want to send</Typography>
              </Toolbar>
              <CampaignContentSMS
                key={0}
                defaultLanguage={defaultLanguage}
                info="Add your message"
                item={messageItem}
                label="Message"
                languages={languages}
                personalizationList={personalizationList}
                changeHandler={this.changeHandler}
              />
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }
}
